export const iconFontAwesomeMarketingAnchorCircleExclamation = (
	<i className="fa-solid fa-anchor-circle-exclamation"></i>
);
